import React, { useEffect, useState } from "react";
import isEqual from "lodash/isEqual";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

export default function AddPricingTierModal({
  show,
  pricingTier,
  handleAdd,
  handleClose,
}) {
  const [tier, setTier] = useState();

  const [isEditing, setIsEditing] = useState(false);

  const [isSameAsInitial, setIsSameAsInitial] = useState(false);

  useEffect(() => {
    if (pricingTier) {
      setIsEditing(true);
      setTier(pricingTier);
    }
  }, [pricingTier]);

  useEffect(() => {
    setIsSameAsInitial(isEqual(pricingTier, tier));
  }, [isEditing, pricingTier, tier]);

  const handleCancel = () => {
    setTier();
    setIsEditing(false);
    handleClose();
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleAdd(tier);
    setTier();
    setIsEditing(false);
  };

  const handleChange = (e) => {
    if (e?.target) {
      setTier({
        ...tier,
        [e.target.name]: e.target.value,
      });
    }
  };

  return (
    <Modal
      centered
      animation={false}
      backdrop="static"
      fullscreen="md-down"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body>
        <div className="modal-body-heading">
          <h1 className="modal-body-heading-title">
            {isEditing ? "Update" : "Add"} Pricing Tier
          </h1>
        </div>
        <Form onSubmit={handleClick}>
          <Stack direction="horizontal" gap={3}>
            <Form.Group className="flex" style={{ flexGrow: "2" }}>
              <Form.Control
                type="text"
                name="name"
                onChange={handleChange}
                value={tier?.name ?? ""}
                aria-label="Tier name"
                placeholder="Enter the tier name"
                required
                autoFocus
              />
            </Form.Group>
            <Form.Group className="flex flex-grow-1 w-25">
              <InputGroup>
                <InputGroup.Text id="price">$</InputGroup.Text>
                <Form.Control
                  placeholder="0.00"
                  id="price"
                  name="price"
                  aria-describedby="price"
                  pattern="^[0-9.]*$"
                  value={tier?.price ?? ""}
                  onChange={(e) =>
                    handleChange(
                      e.target.value === "" || e.target.validity.valid
                        ? e
                        : tier?.price,
                    )
                  }
                  required
                />
              </InputGroup>
            </Form.Group>
          </Stack>

          <Stack direction="horizontal" className="btn-group-flex">
            <Button
              variant="outline-light"
              size="lg"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              size="lg"
              disabled={!tier?.name || !tier?.price || isSameAsInitial}
            >
              {isEditing ? "Update" : "Add"} Tier
            </Button>
          </Stack>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
